import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Vector from "assets/images/Vector.png";

import { Input, Modal, Textarea } from "components";

import { sendMailApi } from "apis";
import useWindowSize, { Size } from "hooks/useWindowSize";
import * as S from "./style";

function Contact() {
  const [foundation, setFoundation] = useState("");
  const [labelFoundation, setLabelFoundation] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [request, setRequest] = useState("");
  const [question, setQuestion] = useState("");
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 768;
  const [isModal, setIsModal] = useState({
    visible: false,
    content: <></>,
  });
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [visibleSelect, setVisibleSelect] = useState(false);
  const [checkClick, setCheckClick] = useState(false);

  const { t, i18n } = useTranslation("common");

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setVisibleSelect(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const dataSelect = [
    {
      label: "COMPANY_ARTNGUIDE",
      value: "ARTNGUIDE",
    },
    {
      label: "COMPANY_YEOLMEA",
      value: "YEOLMAEASSET",
    },
    {
      label: "COMPANY_BBUZZART",
      value: "BBUZZART",
    },
  ];

  const onSubmit = async () => {
    if (!validateEmail(email)) {
      setIsModal({ visible: true, content: t("ERROR_VALIDATE_MAIL") });
    } else {
      setCheckClick(true);
      const resp: any = await sendMailApi({
        content: question,
        emailReceiveResult: email,
        platformCode: foundation,
        senderName: name,
        subject: request,
      });
      if (resp) {
        setCheckClick(false);
        setFoundation("");
        setLabelFoundation("");
        setQuestion("");
        setEmail("");
        setName("");
        setRequest("");

        setIsModal({
          visible: true,
          content: (
            <>
              <div>{t("SUCCESS_SEND_MAIL")}</div>
              <div>{t("SUCCESS_SEND_MAIL1")}</div>
              <div>{t("SUCCESS_SEND_MAIL2")}</div>
            </>
          ),
        });
      }
    }
  };

  const validateEmail = (email: string) => {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  return (
    <S.Container id="contact">
      <Modal
        visible={isModal.visible}
        children={isModal.content}
        onCancel={() => setIsModal({ ...isModal, visible: false })}
      />
      <S.Content>
        <S.TextValue>
          <S.TextTitle>| contact</S.TextTitle>
          <S.TextQuestion>
            {t("What would you like to do with us ?")}
          </S.TextQuestion>
          <S.TextSelect>
            {/* <S.TextSelectDot>
              <div />
            </S.TextSelectDot> */}
            <S.TextSelectContent eng={i18n.language === "en" ? true : false}>
              {t(
                "Please choose the company you want to partner with and leave your inquiry."
              )}
            </S.TextSelectContent>
          </S.TextSelect>
        </S.TextValue>
        <S.FormValue
          success={
            foundation !== "" &&
            name !== "" &&
            email !== "" &&
            request !== "" &&
            question !== ""
              ? true
              : false
          }
        >
          <S.Select className="select" ref={wrapperRef}>
            <div
              className={`content ${
                labelFoundation ? "content--selected" : ""
              }`}
              onClick={() => setVisibleSelect((prev) => !prev)}
            >
              <div>{t(labelFoundation) || t("Choose the business")}</div>
              <img alt="icon down" src={Vector} />
            </div>
            {visibleSelect && (
              <div className="option">
                {dataSelect.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setVisibleSelect(false);
                      setFoundation(item.value);
                      setLabelFoundation(item.label);
                    }}
                    className={
                      labelFoundation === item.label ? "option--selected" : ""
                    }
                  >
                    {t(item.label)}
                  </div>
                ))}
              </div>
            )}
          </S.Select>
          <Input
            className="name"
            placeholder={t("Name")}
            type="text"
            value={name}
            onChange={(e: any) => setName(e.target.value)}
          />
          <Input
            className="email"
            placeholder={t("E-mail address")}
            type="email"
            value={email}
            onChange={(e: any) => setEmail(e.target.value)}
          />
          <Input
            className="request"
            placeholder={t("Subject")}
            type="text"
            value={request}
            onChange={(e: any) => setRequest(e.target.value)}
          />
          <Textarea
            className="question"
            placeholder={t("Inquiry")}
            type="text"
            value={question}
            onChange={(e: any) => setQuestion(e.target.value)}
          />
          <button
            className="submit"
            onClick={onSubmit}
            disabled={
              foundation === "" ||
              name == "" ||
              email == "" ||
              request == "" ||
              question == "" ||
              checkClick
            }
          >
            {t("Submit")}
          </button>
        </S.FormValue>
      </S.Content>
    </S.Container>
  );
}

export default Contact;
